import isEmpty from 'lodash/isEmpty';
import values from 'lodash/values';
import compact from 'lodash/compact';

import {TYPE_OTHER, TYPE_PHYSICAL, TYPE_VIRTUAL} from '../constants';

export const filter = (
  data,
  {languages, locations, products, industries, search: [{label: search}]},
) => {
  return data.filter(item => {
    let A = true;

    if (!isEmpty(products)) {
      const productsForFilter = item.filterProducts;

      let A1 = true;
      let A2 = true;
      const a2 = products.find(i => i.label.toLowerCase() === 'other');
      const a1 = products.length > 1 || !a2;

      if (
        a1 &&
        isEmpty(products.filter(x => productsForFilter.includes(x.label)))
      ) {
        A1 = false;
      }

      if (a2 && !item.otherProducts) {
        A2 = false;
      }

      A = a1 && a2 ? A1 || A2 : A1 && A2;
    }

    if (!isEmpty(locations)) {
      if (
        !locations.find(
          i => i.label === item.country && item.primaryType === TYPE_PHYSICAL,
        ) &&
        !locations.find(
          i => i.label === item.state && item.primaryType === TYPE_PHYSICAL,
        ) &&
        !locations.find(
          i =>
            (i.label === item.onlinePlatform ||
              (!item.onlinePlatform && i.label === TYPE_OTHER)) &&
            item.primaryType === TYPE_VIRTUAL
        )
      ) {
        return false;
      }
    }

    if (!isEmpty(languages)) {
      if (!languages.find(i => i.label === item.language)) {
        return false;
      }
    }

    if (!isEmpty(industries)) {
      if (isEmpty(industries.filter(x => item.industry.includes(x.label)))) {
        return false;
      }
    }

    if (search) {
      const dataForSearch = compact(values(item).map(val => {
        if (Array.isArray(val)) return val.join(', ');
        if (typeof val === 'object') return values(val).join(', ');
        return val;
      })).join(', ').toLowerCase();

      if (!dataForSearch.includes(search.toLowerCase())) return false;
    }

    return A;
  });
};
